interface MultiSelectChipsProps<T> {
  selected: T[];
  getId: (item: T) => string;
  getLabel: (item: T) => string;
  getChipRemoveAria?: (item: T) => string;
  clearAllText?: string;
  onRemove: (item: T) => void;
  onClearAll: () => void;
}

/** Row of removable chips for the current MultiSelect selection. */
export const MultiSelectChips = <T,>({
  selected,
  getId,
  getLabel,
  getChipRemoveAria,
  clearAllText,
  onRemove,
  onClearAll,
}: MultiSelectChipsProps<T>) => {
  if (selected.length === 0) {
    return null;
  }

  return (
    <div className="station-multiselect-chips">
      {selected.map((item) => (
        <span key={getId(item)} className="station-chip">
          {getLabel(item)}
          <button
            type="button"
            onClick={() => onRemove(item)}
            className="station-chip-remove"
            aria-label={getChipRemoveAria?.(item)}
          >
            <span className="material-symbols-outlined">close</span>
          </button>
        </span>
      ))}
      <button type="button" onClick={onClearAll} className="station-clear-all">
        {clearAllText}
      </button>
    </div>
  );
};

export default MultiSelectChips;
